import React, { useState, useEffect, useContext } from "react";
import { useFormik } from "formik";
import { diffAndCommon } from "../../../../services/util";
import validationSchema from "./Validations";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import ImageModal from "../../../../revampComponents/ImageUploader/CropImageModal";
import {
	getEventDetails,
	putEventDetails
} from "../../../../revampCRUD/organizerNbankdetails.crud";
import customToast from "../../../../components/common/basic/Toast";
import iconBG from "../../../../revampComponents/Atom/Icons/iconBG.svg";
import iconEdit from "../../../../revampComponents/Atom/Icons/iconEdit.svg";
import iconDelete from "../../../../revampComponents/Atom/Icons/iconDelete.svg";
import LoadingSpinner from "../../../../revampComponents/Atom/Loading";
import FormButtons from "../../../../revampComponents/Molecule/Buttons/FormButtons";
import FileUpload from "../../../../revampComponents/Molecule/Inputs/FileUpload/FileUpload";

import UploadImageButton from "../../../../revampComponents/ImageUploader/uploadImageButton";
import RouteModal from "../../../../revampComponents/Atom/Modals/RouteModal";
import TippyIcon from "../../../../revampComponents/Atom/TippyIcon";
import { errorToaster, regexMethods, sanitizeString } from "../../../../reusable/common";
import { scrollToError } from "../../../../Utils/helpers";
import { CHAR_LIMITS } from "../../config/constants";
import AuthContext from "../../../../contexts/AuthContext";
import customCardImage from "../../../../assets/img/common/bg.svg";
import RichTextEditor from "../../../../revampComponents/TipTapEditorNew/components/RichTextEditor";
import RTE from "../../../../revampComponents/TipTapEditor/RTE";
import EditorCustomTemplate from "../../../../revampComponents/Atom/EditorCustomTemplate";
import { dashboardColors, theme } from "../../../../themes/Theme";
import { PhoneNumberInput } from "kh-design-system/components";
import { GetEventProfileById, EditEventProfileApi } from "../../../../revampCRUD/eventProfile.curd";
import { countryCode, countryDialCodes } from "../../../../reusable/country";

const Organiser = props => {
	const [listOfEvents, setListOfEvents] = useState({
		organiser_name: "",
		organiser_email: "",
		organiser_info: "",
		organiser_dial_code: "",
		organiser_country_code: "",
		organiser_phone: "",
		organiser_website: "",
		organizer_facebook_url: "",
		organizer_twitter_url: "",
		organiser_image_url: "",
		organizer_linkedin_url: ""
	});

	//UseState for edit image
	const [editImage, setEditImage] = useState(false);
	const isKonfHubUser = true;

	//UseState for loading
	const [loading, setLoading] = useState(false);
	const [isApiCalled, setIsApiCalled] = useState(false);
	const [error, setError] = useState(false);

	const isEventProfile = props.module === "event-profile";

	// calling the event API to get initial values.
	const EventDetailsAPI = async () => {
		try {
			const eventRes = await getEventDetails(props.eventInfo.event_id);
			if (eventRes.status === 200) {
				var changeValues = { ...eventRes.data };
				Object.keys(changeValues).map(function (key, value) {
					if (changeValues[key] == null) {
						changeValues[key] = "";
					}
				});
				if (!changeValues.organiser_country_code && !changeValues.organiser_dial_code) {
					const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
					const countryIso = countryCode[timezone];
					const matched = countryDialCodes.find(c => c.code === countryIso);

					if (countryIso && matched) {
						changeValues.organiser_country_code = countryIso.toLowerCase();
						changeValues.organiser_dial_code = matched.dialCode;
					}
				}
				setListOfEvents(changeValues);
			} else {
				customToast.success("Something went wrong");
			}
		} catch (err) {
			console.log("err", err);
			customToast.error("Internal Server error");
		} finally {
			setIsApiCalled(true);
		}
	};
	const fetchEventProfileDetails = async () => {
		try {
			const response = await GetEventProfileById(props?.profileId);
			if (response && response.data) {
				var changeValues = { ...response.data.event_profile };
				Object.keys(changeValues).map(function (key, value) {
					if (changeValues[key] == null) {
						changeValues[key] = "";
					}
				});
				if (!changeValues.organiser_country_code && !changeValues.organiser_dial_code) {
					const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
					const countryIso = countryCode[timezone];
					const matched = countryDialCodes.find(c => c.code === countryIso);

					if (countryIso && matched) {
						changeValues.organiser_country_code = countryIso.toLowerCase();
						changeValues.organiser_dial_code = matched.dialCode;
					}
				}
				setListOfEvents(changeValues);
			}
		} catch (error) {
			customToast.error("Something went wrong");
		} finally {
			setIsApiCalled(true);
		}
	};

	useEffect(() => {
		if (!isEventProfile) {
			EventDetailsAPI();
		}
		else {
			fetchEventProfileDetails();
		}
	}, []);

	// calling the putEventDetails API
	const onSubmit = async values => {
		const updated_details = diffAndCommon("diff", [values, formik.initialValues], []);
		if (!updated_details.organiser_dial_code) updated_details.organiser_dial_code = "+91";
		if (!updated_details.organiser_country_code) updated_details.organiser_country_code = "in";
		setLoading(true);
		try {
			let dataSendAPI = {};
			if (!isEventProfile) {
				dataSendAPI = await putEventDetails(updated_details, props.eventInfo.event_id);
			}
			else {
				dataSendAPI = await EditEventProfileApi(props?.profileId, updated_details);
			}
			if (dataSendAPI.data == "OK" || dataSendAPI.data == "Profile Updated Successfully") {
				customToast.success("Organizer details updated successfully");
				setListOfEvents(formik.values);
				setEditImage(false);
				setLoading(false);
			} else {
				setLoading(false);
				customToast.error("Something went wrong");
			}
		} catch (err) {
			setLoading(false);
			console.log("err", err);
			customToast.error("Internal Server error");
		}
	};

	const formik = useFormik({
		initialValues: listOfEvents,
		validationSchema,
		enableReinitialize: true,
		onSubmit
	});

	// useEffect(() => {
	// 	if(formik.dirty) setOpenModal(true)
	// 	console.log(formik.dirty);
	// }, [formik])

	//updateContent is for changing content in description
	const updateContent = description => {
		const cleanContent = sanitizeString(description);
		formik.setFieldValue("organiser_info", cleanContent);
	};

	//toolbar for description
	const toolbar =
		"bold italic | " +
		"underline strikethrough | " +
		"blockquote removeformat | forecolor backcolor | " +
		"numlist bullist| " +
		"link unlink | hr | fullscreen |";
	// phone number
	const [blur, setBlur] = useState(false);
	const handleClick = () => setBlur(true);

	//For Image
	const [uploadedImage, setuploadedImage] = useState("");
	const [imageModal, setImageModal] = useState(false);
	const [imageRef, setImageRef] = useState("");
	const [imageInput, setImageInput] = useState("");
	const [previewLogoUrl, setPreviewLogoUrl] = useState("");
	const imageModuleNo = 5;

	useEffect(() => {
		//On edit poster image and organiser image should be shown in preview
		if (formik && formik.values && formik.values.organiser_image_url) {
			setPreviewLogoUrl(formik.values.organiser_image_url);
		}
	}, [formik.values]);

	// function to set organizer image
	const imageHandler = (imageUrl, previewUrl) => {
		formik.setFieldValue("organiser_image_url", imageUrl);
		setPreviewLogoUrl(previewUrl);
	};

	// function to open image model
	const openImageModal = e => {
		if (e.target.files[0].size < 614400) {
			setImageRef(e.target);
			setImageModal(true);
			setuploadedImage(e.target);
			setImageInput(e.target.name);
			setEditImage(true);
		} else {
			errorToaster("Image size is greater than 600 KB. It should be less than 600KB.");
		}
	};

	// function to edit image model
	const EditImageModal = () => {
		setImageModal(true);
		setImageInput("organiser_image_url");
		setImageRef(uploadedImage);
	};
	//function to close image model on click on cancel button
	const closeImageModal = () => {
		setImageRef("");
		setImageModal(false);
	};

	//function used to remove selected image
	const removeSelectedImage = () => {
		formik.setFieldValue("organiser_image_url", "");
		setPreviewLogoUrl("");
	};

	return (
		<>
			<RouteModal shouldBlock={formik.dirty} />
			{isApiCalled ? (
				<div className="px-4 pt-2">
					<form onSubmit={formik.handleSubmit}>
						<div className="row">
							{/* Name field (mandatory) */}
							<div className="col-12 col-md-6 pt-1">
								<div>
									<label htmlFor="organiser_name" className="label mt-2">
										Name<span className="text-danger"> *</span>
									</label>
								</div>
								<div>
									<input
										id="organiser_name"
										name="organiser_name"
										placeholder="John"
										type="text"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.organiser_name}
										className={
											formik.errors.organiser_name &&
												formik.touched.organiser_name
												? "input border-danger box-shawdow-none"
												: "input"
										}
									/>
									{formik.errors.organiser_name &&
										formik.touched.organiser_name && (
											<p className="text-danger">
												{formik.errors.organiser_name}
											</p>
										)}
								</div>
							</div>
							{/* Email field (mandatory) */}
							<div className="col-12 col-md-6 pt-1">
								<div>
									<label htmlFor="email" className="label mt-2">
										Email<span className="text-danger"> *</span>
									</label>
								</div>
								<div>
									<input
										id="organiser_email"
										name="organiser_email"
										placeholder="johndoe@gmail.com"
										type="text"
										onKeyPress={e => regexMethods.noSpaces(e)}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.organiser_email}
										className={
											formik.errors.organiser_email &&
												formik.touched.organiser_email
												? "input border-danger box-shawdow-none"
												: "input"
										}
									/>
									{formik.errors.organiser_email &&
										formik.touched.organiser_email && (
											<p className="text-danger">
												{formik.errors.organiser_email}
											</p>
										)}
								</div>
							</div>

							{/* Organizer field (optional)*/}
							<div className="col-12 col-md-12 pt-1">
								<div>
									<label htmlFor="organiser_info" className="label mt-2">
										Description
									</label>
								</div>
								<div>
									{isApiCalled && <RichTextEditor
										content={sanitizeString(formik.values.organiser_info)}
										onChangeContent={updateContent}
										placeholder="Enter your description here"
										showTextFormatters
										showTextHighlighters
										showHistory
										showTextAligners
										showLists
										showTable
										showImage
										showVideo
										showBlockQuote
										showHr
										showLink
										showSlashCommand
									/>}

									{/* {!isKonfHubUser ? (
										<EditorCustomTemplate
											content={formik.values.organiser_info}
											updateContent={updateContent}
											placeholder={`Enter your description here`}
											toolbar={toolbar}
											heightCustom={200}
											formik={formik}
										/>
									) : (
										isApiCalled && <RTE
											value={formik.values.organiser_info}
											onChange={updateContent}
											placeholder="Enter your description here"
										/>
									)} */}
									<div className="d-flex justify-content-between">
										<p className="text-danger pt-1 mb-0">
											{formik.errors.organiser_info &&
												formik.touched.organiser_info && (
													<p>{formik.errors.organiser_info}</p>
												)}
										</p>
										<p className="maxCharForInput">
											Maximum Characters: {CHAR_LIMITS.organizer.descMax}
										</p>
									</div>
								</div>
							</div>

							{/* Phone Number field (optional) with country code dial code and the phone number*/}
							<div className="col-12 col-md-6 pt-1">
								<div>
									<label htmlFor="organiser_phone" className="label mt-3">
										Phone Number
									</label>
								</div>
								<div>
									<IntlTelInput
										format={false}
										formatOnInit={false}
										fieldName="organiser_phone"
										fieldId="organiser_phone"
										separateDialCode={true}
										customPlaceholder={(placeholder, props) => {
											if (props.iso2 === "in") return "9876543210";
											else return placeholder;
										}}
										css={["intl-tel-input"]}
										preferredCountries={["in"]}
										value={formik.values.organiser_phone}
										onBlur={formik.handleBlur}
										containerClassName={
											formik.errors.organiser_phone &&
												formik.touched.organiser_phone == true
												? "intl-tel-input intl-tel-input-cus phone-input-container input border-danger box-shawdow-none"
												: "intl-tel-input intl-tel-input-cus phone-input-container"
										}
										inputClassName="input-tel phonecus phone-input"
										defaultCountry={
											formik.values.organiser_country_code || "in"
										}
										onPhoneNumberChange={(
											status,
											value,
											countryData,
											number,
											id
										) => {
											const tempValue = value.replace(/\s/g, "");
											formik.setFieldValue("organiser_phone", tempValue);
										}}
										onPhoneNumberBlur={(
											status,
											value,
											countryData,
											number,
											id
										) => {
											const tempValue = value.replace(/\s/g, "");
											formik.handleBlur("organiser_phone");
											formik.setFieldValue("organiser_phone", tempValue);
											handleClick(true);
											formik.touched["organiser_phone"] = true;
										}}
										onSelectFlag={(number, country) => {
											formik.setFieldValue(
												"organiser_dial_code",
												"+" + country.dialCode
											);
											formik.setFieldValue(
												"organiser_country_code",
												country.iso2
											);
										}}
									/>

									{formik.errors.organiser_phone &&
										formik.touched.organiser_phone && (
											<p className="text-danger">
												{formik.errors.organiser_phone}
											</p>
										)}
								</div>
							</div>
							{/* Website Text field(optional)*/}
							<div className="col-12 col-md-6 pt-1">
								<div>
									<label htmlFor="organiser_website" className="label mt-3">
										Website
									</label>
								</div>
								<div>
									<input
										id="organiser_website"
										name="organiser_website"
										placeholder="https://www.konfhub.com"
										type="text"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.organiser_website}
										className={
											formik.errors.organiser_website &&
												formik.touched.organiser_website
												? "input border-danger box-shawdow-none"
												: "input"
										}
									/>
									{formik.errors.organiser_website &&
										formik.touched.organiser_website && (
											<p className="text-danger">
												{formik.errors.organiser_website}
											</p>
										)}
								</div>
							</div>
							{/* Facebook Link field (optional)*/}
							<div className="col-12 col-md-6 pt-1">
								<div>
									<label htmlFor="organizer_facebook_url" className="label mt-2">
										Facebook Link
									</label>
								</div>
								<div className="mb-3">
									<input
										id="organizer_facebook_url"
										name="organizer_facebook_url"
										type="text"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.organizer_facebook_url}
										className={
											formik.errors.organizer_facebook_url &&
												formik.touched.organizer_facebook_url
												? "input border-danger box-shawdow-none"
												: "input"
										}
										placeholder="https://www.facebook.com/"
									/>
									{formik.errors.organizer_facebook_url &&
										formik.touched.organizer_facebook_url && (
											<p className="text-danger">
												{formik.errors.organizer_facebook_url}
											</p>
										)}
								</div>
							</div>
							{/*Twitter Link field (optional)*/}
							<div className="col-12 col-md-6 pt-1">
								<div>
									<label htmlFor="organizer_twitter_url" className="label mt-2">
										Twitter Link
									</label>
								</div>
								<div className="mb-1">
									<input
										id="organizer_twitter_url"
										name="organizer_twitter_url"
										type="text"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.organizer_twitter_url}
										className={
											formik.errors.organizer_twitter_url &&
												formik.touched.organizer_twitter_url
												? "input border-danger box-shawdow-none"
												: "input"
										}
										placeholder="https://twitter.com/"
									/>
									{formik.errors.organizer_twitter_url &&
										formik.touched.organizer_twitter_url && (
											<p className="text-danger">
												{formik.errors.organizer_twitter_url}
											</p>
										)}
								</div>
							</div>

							{/* Organizer Image field (Mandatory)*/}
							<div className="col-12 col-md-6 pb-4">
								<div>
									<label className="label mt-2">Organizer Image</label>
								</div>
								<div>
									{!previewLogoUrl && (
										<div>
											<FileUpload
												onChange={imageHandler}
												moduleNumber={imageModuleNo}
												aspect={1 / 1}
											>
												<UploadImageButton size="90px" />
												<p className="recommend ">
													Recommended dimension is 1:1
												</p>
											</FileUpload>
										</div>
									)}

									{formik.errors.organiser_image_url &&
										formik.touched.organiser_image_url && (
											<p className="text-danger">
												{formik.errors.organiser_image_url}
											</p>
										)}
								</div>
								<div className="d-flex pt-1">
									{previewLogoUrl && (
										<div style={{ position: "relative" }}>
											<img
												alt="Crop"
												style={{
													padding: "2px",
													maxWidth: "200px",
													maxHeight: "200px",
													width: "85px",
													height: "82px",
													border: `2px solid ${dashboardColors[theme].primary}`
												}}
												className="organiser-image"
												src={previewLogoUrl}
											/>
											{editImage == true && (
												<div>
													<label
														style={{ bottom: "0" }}
														onClick={EditImageModal}
													>
														{" "}
														<span
															style={{
																position: "absolute",
																top: "-8%",
																right: "-10%"
															}}
														>
															<TippyIcon content="Edit">
																<img
																	style={{
																		backgroundImage: `url(${iconBG})`,
																		backgroundPosition:
																			"center",
																		backgroundSize: "cover",
																		backgroundRepeat:
																			"no-repeat",
																		padding: "3.5px 3px",
																		height: "19px",
																		width: "19px",
																		cursor: "pointer"
																	}}
																	src={iconEdit}
																/>
															</TippyIcon>
														</span>
													</label>
												</div>
											)}

											<div>
												<label
													style={{ bottom: "0" }}
													onClick={removeSelectedImage}
												>
													{" "}
													<span
														style={
															editImage == false
																? {
																	position: "absolute",
																	top: "60%",
																	right: "-10%"
																}
																: {
																	position: "absolute",
																	top: "50%",
																	right: "-10%"
																}
														}
													>
														<TippyIcon content="Delete">
															<img
																style={{
																	backgroundImage: `url(${iconBG})`,
																	backgroundPosition: "center",
																	backgroundSize: "cover",
																	backgroundRepeat: "no-repeat",
																	padding: "3.5px 3px",
																	height: "19px",
																	width: "19px",
																	cursor: "pointer"
																}}
																src={iconDelete}
															/>
														</TippyIcon>
													</span>
												</label>
											</div>
										</div>
									)}
								</div>
							</div>

							{/* LinkedIn field (optional)*/}
							<div className="col-12 col-md-6 pb-4">
								<div>
									<label htmlFor="organizer_linkedin_url" className="label mt-0">
										LinkedIn Link
									</label>
								</div>
								<div>
									<input
										id="organizer_linkedin_url"
										name="organizer_linkedin_url"
										type="text"
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										value={formik.values.organizer_linkedin_url}
										className={
											formik.errors.organizer_linkedin_url &&
												formik.touched.organizer_linkedin_url
												? "input border-danger box-shawdow-none"
												: "input"
										}
										placeholder="https://www.linkedIn.com/"
									/>
									{formik.errors.organizer_linkedin_url &&
										formik.touched.organizer_linkedin_url && (
											<p className="text-danger">
												{formik.errors.organizer_linkedin_url}
											</p>
										)}
								</div>
							</div>
						</div>

						<ImageModal
							show={imageModal}
							imageHandler={imageHandler}
							closeModal={closeImageModal}
							imageHandlerFunc={imageHandler}
							moduleNo={imageModuleNo}
							imageRef={imageRef}
						/>

						<div className="mt-2 loadingCenter padding15">
							<FormButtons
								isLoading={loading}
								formik={formik}
								onSave={() => {
									scrollToError(formik); //scroll to error if errors
									formik.submitForm();
								}}
								onCancel={() => {
									formik.handleReset();
								}}
								saveBtnContent="Save"
								cancelBtnDisabled={!formik.dirty}
								saveBtnDisabled={loading || !formik.dirty}
							/>
						</div>
					</form>
				</div>
			) : (
				<LoadingSpinner />
			)}
			<style>{`
		.organiser-image{
		    background-image: url(${customCardImage});
			background-size: cover;
			background-repeat: no-repeat;
		}	
		.recommend{
            font-family: 'Nunito' !important;
            font-style: normal !important;
            font-weight: 400 !important;
            font-size: 12px !important;
            line-height: 16px !important;
            color: #6D7780 !important;
        }

		.phone-input-container {
			width: 100%;
			padding: 0px;
		}
		.phone-input {
			width: 100%;
			height: 34px;
			border: 1px solid #cdd4db!important;
		}
		.phone-input:hover {
			border: 1px solid #cdd4db!important;
		}
		.phone-input:focus {
			border-color: ${dashboardColors[theme].primaryTextColor} !important;
		}
		.phone-input-wrapper:focus-within{
			border-color: ${dashboardColors[theme].primaryTextColor} !important;
			box-shadow:none !important;
		}
		.country-selector{
			border-radius: 3px 0px 3px 0px;
		}
	`}</style>
		</>
	);
};

export default Organiser;
